__turbopack_context__.v({
  "contentWrapper": "Accordion-module-scss-module__y5beuW__contentWrapper",
  "header": "Accordion-module-scss-module__y5beuW__header",
  "icon": "Accordion-module-scss-module__y5beuW__icon",
  "icon_open": "Accordion-module-scss-module__y5beuW__icon_open",
  "main": "Accordion-module-scss-module__y5beuW__main",
});
